"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDocumentDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
class UpdateDocumentDto {
}
exports.UpdateDocumentDto = UpdateDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "ID of the document map", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateDocumentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID associated with the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateDocumentDto.prototype, "documentId", void 0);
